import { makeStyles, typographyStyles, tokens } from "@fluentui/react-components";

export const useRiskAnalysisStyles = makeStyles({
  // === Layout Containers ===
  container: {
    marginBottom: tokens.spacingVerticalL,
  },
  configContainer: {
    marginBottom: tokens.spacingVerticalM,
    display: "flex",
    alignItems: "flex-end",
    gap: tokens.spacingHorizontalXS,
  },
  configInnerContainer: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalXS,
  },
  configButtonContainer: {
    display: "flex",
    alignItems: "flex-start",
    gap: tokens.spacingHorizontalXS,
  },
  dropdownsContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "fit-content",
  },

  // === Titles and Text ===
  classificationResultsTitleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: tokens.spacingHorizontalXS,
    marginBottom: tokens.spacingVerticalXS,
  },
  classificationResultsTitle: {
    ...typographyStyles.subtitle2Stronger,
    display: "block",
  },
  loadingText: {
    marginLeft: tokens.spacingHorizontalS,
  },

  // === States ===
  loading: {
    height: "calc(100vh - 100px)",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  emptyState: {
    height: "calc(100vh - 100px)",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  // === Results and Errors ===
  classificationContainer: {
    marginTop: tokens.spacingVerticalXS,
    whiteSpace: "pre-wrap",
  },
  errorsContainer: {
    border: `1px solid ${tokens.colorPaletteRedForeground1}`,
    borderRadius: tokens.borderRadiusMedium,
    padding: tokens.spacingVerticalL,
    margin: `${tokens.spacingVerticalL} 0`,
    textAlign: "left",
  },
  errorTitle: {
    color: tokens.colorPaletteRedForeground1,
    fontSize: "1.125rem",
    marginBottom: tokens.spacingVerticalXS,
  },
  errorField: {
    fontWeight: 700,
  },

  // === Buttons ===
  generateReportBtn: {
    alignSelf: "flex-start",
    textDecoration: "none",
    transition: "background 0.2s",
  },

  // === Misc ===
  logo: {
    position: "absolute",
    left: "0.75rem",
    top: "50%",
    transform: "translateY(-50%)",
  },
});
